import { useEffect } from "react";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (value == null || value === "") {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({
  title, description, path, image, jsonLd, noIndex = false,
  canonicalUrl, socialTitle, socialDescription, socialImage,
  ogType = "website",
}) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("name", "description", description);
    const fallbackUrl = path ? window.location.origin + path : window.location.href;
    let url = fallbackUrl;
    if (canonicalUrl && !noIndex) {
      try {
        const candidate = new URL(canonicalUrl, window.location.origin);
        if (candidate.protocol === "https:" || candidate.protocol === "http:") url = candidate.href;
      } catch { /* Keep the generated page URL when the optional canonical is invalid. */ }
    }
    const imageUrl = socialImage || image;
    const resolvedImage = imageUrl
      ? (() => { try { return new URL(imageUrl, window.location.origin).href; } catch { return image; } })()
      : undefined;
    const resolvedSocialTitle = socialTitle || title;
    const resolvedSocialDescription = socialDescription || description;
    setLink("canonical", noIndex ? null : url);
    setMeta("name", "robots", noIndex ? "noindex,follow" : null);
    setMeta("property", "og:title", resolvedSocialTitle);
    setMeta("property", "og:description", resolvedSocialDescription);
    setMeta("property", "og:type", ogType);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", resolvedImage);
    setMeta("name", "twitter:image", resolvedImage);
    setMeta("name", "twitter:card", resolvedImage ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", resolvedSocialTitle);
    setMeta("name", "twitter:description", resolvedSocialDescription);

    let script = document.getElementById("aran-jsonld");
    if (jsonLd && !noIndex) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "aran-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, image, jsonLd, noIndex, canonicalUrl, socialTitle, socialDescription, socialImage, ogType]);

  return null;
}
